import {getCurrentLayout} from "../../appLayout";
import store from "../../../store";
import config from "../components/canvas/store/sqftConfig";
//import ManualCalculate from "../components/canvas/core/controls/manualCalculate";
import Radius from "../components/canvas/core/controls/radius";
import workspace from "../components/canvas/core/workspace";
import history from "../components/canvas/core/workspaceHistory";
import {enableSquareFootage, setSquareFootageGroup, updateSQFTCalculations} from "../../../actions/sqftFunctions";
import {toggleSelectionFeatureInfo} from "../../../actions/actionFunctions";
import {manualCalculateImport} from "./sqftDataMapper";
import {getInitialManualCalcRows} from "../../../reducers/sqftManualCalculationReducer";
import {updateManualCalculateRows} from "../../../actions/sqftManualCalculationFunctions";
import {hashHistory} from "react-router";
import {getAvailableSteps, navItemIsExcluded} from "../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";

export const getFeatureGroup = (mainNeeded = "center_island_countertop") => {
  const layout = getCurrentLayout();
  let featureGroup = layout.getSubPartFromQtCategories(mainNeeded);
  if (!featureGroup) {
    const foundGroup = layout.getFeatureGroupByPartId(mainNeeded);
    if (foundGroup) {
      featureGroup = {part: foundGroup}
    }
  }
  if (!featureGroup) {
    featureGroup = layout.parts["Countertop"] && layout.parts["Countertop"].countertop
      ? {part: layout.parts["Countertop"].countertop}
      : null;
  }

  return featureGroup
}

export const getNavItems = (featureGroup, searchText = "", withPlaceholders = true,  withQuotingToolFeatures = false) => {
  const layout = getCurrentLayout();

  return featureGroup
    ? layout.designNavigationItems(featureGroup, {}, searchText, withPlaceholders, withQuotingToolFeatures)
    : [];
}

export const onSQFTLoadPrepareData = () => {
  const layout = getCurrentLayout();
  const state = store.getState();
  const quotes = state.quotesState.quotes;
  const activeQuoteIndex = state.quotesState.activeQuoteIndex;
  const filterGroups = state.filterState.filterGroups;
  const fabricatorData = state.fabricatorState;

  //if (this.iframeElement && this.iframeElement.contentWindow) {
  const activeQuote = quotes[activeQuoteIndex];
  //const {intl, fabricatorData} = this.props;
  const measureUnit = fabricatorData.settings.measureUnit;
  const payload = {
    loadData: (activeQuote && activeQuote.sqFtCalcData) ? activeQuote.sqFtCalcData : null,
    measureUnit,
    fabricatorId: document.kvConfig.userId,
    fabricatorData,
    currentLayout: layout.getCurrentLayoutAbbreviation(),
    filterGroups: filterGroups,
    //language: intl.locale
  }
  // if (hardCodeIsLowes()) {
  //   let translates = {}
  //   Object.keys(intl.messages).forEach(messageKey => {
  //     if (messageKey.startsWith("transDoc.")) {
  //       if (!translates[intl.locale]) {
  //         translates[intl.locale] = {};
  //       }
  //       translates[intl.locale][messageKey] = intl.messages[messageKey]
  //     }
  //   })
  //   payload.translates = translates;
  // }
  console.log("sqft postMessage initial load data:", payload);

  return payload;
  //}
};

//todo is this all needed?
export const onSQFTLoadImport = (payload) => {
  let {fabricatorId, fabricatorData, currentLayout, measureUnit, loadData, filterGroups} = payload;
  config.fabricatorData = fabricatorData;
  window.fabricatorId = fabricatorId;
  window.currentLayout = currentLayout;
  config.filterGroups = filterGroups;
  //TranslatesProvider.replaceHtml(language, translates);
  // config.fabricatorData = fabricatorData; // set if needed

  //todo
  //toolbar.setFabricatorButtons(fabricatorData); // specific fabricator rules
  if (measureUnit) {
    [].slice.call(document.querySelectorAll(".settings-units [data-value]")).forEach(element => {
      (element.dataset.value === measureUnit)
        ? element.classList.add("active")
        : element.classList.remove("active")
    });
    config.measureUnit = measureUnit;
    history.rememberConfig({measureUnit});
    //todo
    //ManualCalculate.onMeasureUnitChange();
    Radius.onMeasureUnitChange();
  }
  if (loadData) {
    loadData = (typeof loadData === 'string') ? JSON.parse(loadData) : loadData;
    if (loadData.manualCalculate === true) {
      manualCalculateImport(loadData);
    } else {
      workspace.import(loadData);
    }
  } else if (!config.tutorialIsRunning) {
    workspace.import({}); // if new room is opened - clear the previous(but not the first time if tutorial is active)
    store.dispatch(updateManualCalculateRows(getInitialManualCalcRows()));
    //todo
    //ManualCalculate.import({})
  }
  const state = store.getState();
  const updateCalculations = state.sqftState.updateCalculations;
  store.dispatch(updateSQFTCalculations(updateCalculations + 1));
}

export const closeSQFTTool = (redirectToPage, shouldChangeWizardToNextStep, changeWizardStepRoute) => {
  const isSQFTinUrl = window.location.hash.includes("sqft");

  if (isSQFTinUrl) {
    hashHistory.push(redirectToPage);
  } else {
    store.dispatch(enableSquareFootage(false));
    store.dispatch(setSquareFootageGroup(null));
    if (shouldChangeWizardToNextStep) {
      changeWizardToNextStep(changeWizardStepRoute)
    }
  }
}

export const changeWizardToNextStep = (changeWizardStepRoute) => {
  const state = store.getState();
  const {wizardIsActive, wizardActiveStep} = state.wizardState;
  const {selectionFeatureInfo} = state.selectionState;
  if (wizardIsActive) {
    if (selectionFeatureInfo) {
      store.dispatch(toggleSelectionFeatureInfo(null));
    }
    changeWizardStepRoute(wizardActiveStep + 1);//changeWizardStepRoute(wizardActiveStep + 1);
  }
}

export const getNavItemsFromTheWizard = (subPart, wizardGroupId = null) => {
  const wizardSteps = getWizardGroupsFromTheWizard(subPart.part.dbName || subPart.part.partName, wizardGroupId);
  const layout = getCurrentLayout();
  const navItems = layout.designNavigationItems(subPart, {}, "", false, true);

  // console.log("wizardSteps", wizardSteps);
  let allNavItems = [];
  if (wizardSteps.length) {
    if (wizardSteps.length === 1) {
      const navItemsFromWizardGroup = navItems.filter(navItem => !navItemIsExcluded(navItem, wizardSteps[0][0]));
      if (navItemsFromWizardGroup.length) {
        allNavItems = navItemsFromWizardGroup
      }
    } else {
      for (const wizardStep of wizardSteps) {
        const navItemsFromWizardGroup = navItems.filter(navItem => !navItemIsExcluded(navItem, wizardStep[0]));
        if (navItemsFromWizardGroup.length) {
          if (!allNavItems.length) {
            allNavItems = navItemsFromWizardGroup
          } else {
            navItemsFromWizardGroup.forEach(newNavItem => {
              if (!allNavItems.some(navItem => navItem.part.dbFeature.id === newNavItem.part.dbFeature.id)) {
                allNavItems.push(newNavItem)
              }
            })
          }
        }
      }
    }
  }

  return allNavItems
}

export const getWizardGroupsFromTheWizard = (groupName, wizardGroupId = null) => {
  const state = store.getState();
  const {wizardActiveItem, wizardSelectedValues} = state.wizardState;
  const wizardSteps = getAvailableSteps(wizardActiveItem, wizardSelectedValues, true);

  return wizardSteps.map(wizardStep => {
    return wizardStep.stepGroups.filter(stepGroup => {
      return stepGroup.groupName === groupName && (!wizardGroupId || (stepGroup.id === wizardGroupId))
    });
  }).filter(wizardStep => wizardStep.length > 0);
}

